"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDraftStruct = exports.TWITTER_FOLLOWERS_THRESHOLD = exports.UNKNOWN_MINT_DATE = exports.LIST_NOW = exports.TOTAL_SUPPLY_LIMIT = exports.HASH_LIST_LIMIT = exports.ArtPermissions = exports.OrdLabel = exports.MmmStatus = exports.Blockchain = exports.ApplyPurposes = exports.Sources = exports.ListingSubmissionState = void 0;
const v = __importStar(require("superstruct"));
const util_1 = require("../util");
const shared_1 = require("./shared");
var ListingSubmissionState;
(function (ListingSubmissionState) {
    ListingSubmissionState["INTRO"] = "intro";
    ListingSubmissionState["GENERAL"] = "general";
    ListingSubmissionState["DETAILS"] = "details";
    ListingSubmissionState["PROGRAM"] = "program";
    ListingSubmissionState["SUBMIT"] = "submit";
})(ListingSubmissionState = exports.ListingSubmissionState || (exports.ListingSubmissionState = {}));
var Sources;
(function (Sources) {
    Sources["NONE"] = "";
    Sources["CM_V2"] = "candymachine_v2";
    Sources["LAUNCHPAD"] = "launchpad";
    Sources["LMNFT"] = "launch_my_nft";
    Sources["MONKELABS"] = "monkelabs";
    Sources["NOVALAUNCH"] = "novalaunch";
    Sources["OPENSEA"] = "opensea";
    Sources["UNKNOWN"] = "unknown";
})(Sources = exports.Sources || (exports.Sources = {}));
var ApplyPurposes;
(function (ApplyPurposes) {
    ApplyPurposes["PRE_APPROVAL"] = "pre_approval";
    ApplyPurposes["LISTING_NOW"] = "listing_now";
})(ApplyPurposes = exports.ApplyPurposes || (exports.ApplyPurposes = {}));
var Blockchain;
(function (Blockchain) {
    Blockchain["SOL"] = "solana";
    Blockchain["ETH"] = "ethereum";
    Blockchain["MATIC"] = "polygon";
    Blockchain["BTC"] = "bitcoin";
})(Blockchain = exports.Blockchain || (exports.Blockchain = {}));
var MmmStatus;
(function (MmmStatus) {
    MmmStatus["NONE"] = "";
    MmmStatus["AVAILABLE"] = "available";
    MmmStatus["UNAVAILABLE"] = "unavailable";
    MmmStatus["REVIEW_NEEDED"] = "review_needed";
    MmmStatus["AUTOLIST"] = "autolist";
})(MmmStatus = exports.MmmStatus || (exports.MmmStatus = {}));
var OrdLabel;
(function (OrdLabel) {
    OrdLabel["ONCHAIN"] = "ONCHAIN";
    OrdLabel["OFFCHAIN"] = "OFFCHAIN";
    OrdLabel["RECURSIVE"] = "RECURSIVE";
    OrdLabel["CURSED"] = "CURSED";
})(OrdLabel = exports.OrdLabel || (exports.OrdLabel = {}));
var ArtPermissions;
(function (ArtPermissions) {
    ArtPermissions["AUTHOR"] = "author";
    ArtPermissions["LICENSED"] = "licensed";
})(ArtPermissions = exports.ArtPermissions || (exports.ArtPermissions = {}));
/**
 * Constants
 */
// maximum number of hashes in mint array
exports.HASH_LIST_LIMIT = 150000;
exports.TOTAL_SUPPLY_LIMIT = 10000000;
exports.LIST_NOW = 'list now';
exports.UNKNOWN_MINT_DATE = 'unknown mint date';
// minimal number of twitter followers to attach to a collection draft
exports.TWITTER_FOLLOWERS_THRESHOLD = 100;
/**
 * Validation
 */
exports.CollectionDraftStruct = v.object({
    name: util_1.collectionName,
    symbol: util_1.collectionSymbol,
    description: v.size(v.string(), 10, 1000),
    assets: v.object({
        profileImage: v.string(),
        inscriptionIcon: v.optional(v.string()),
    }),
    derivative: v.nullable(v.object({
        originalLink: (0, util_1.notEmpty)(v.string()),
        originalName: v.size(v.string(), 3, 128),
    })),
    categories: v.object({
        primary: v.enums(Object.values(shared_1.CollectionCategories)),
        secondary: v.nullable(v.enums(Object.values(shared_1.CollectionCategories))),
    }),
    links: v.object({
        twitter: v.string(),
        discord: v.optional(v.string()),
        website: v.optional(v.string()),
        mint: v.optional(v.string()),
    }),
    mintDate: v.optional(v.nullable((0, util_1.isodate)(v.string()))),
    candyMachineIds: v.array(v.string()),
    creatorTipsAddress: v.optional(v.nullable(v.string())),
});
